module.exports = __webpack_public_path__ + "img/arrow_left.add3ba39.svg";